import React, { useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

// @YUp
import * as Yup from "yup";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import API from "../../utils/Axios.utils";
import { Country, State, City } from "country-state-city";
import DeleteIcon from "@mui/icons-material/Delete";
import { Notification } from "../../utils/Notification";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useDebounce from "../../utils/useDebounce";

const EditSupplier = () => {
  const classes = {};
  const navigate = useNavigate();

  const location = useLocation();
  const supplierDetails = location.state?.supplierDetails;

  const fileInputRefs = {
    GST: useRef(null),
    CIN: useRef(null),
    PAN: useRef(null),
  };

  // const initialSkills = supplierDetails.skills.map((skill, index) => ({
  //   id: Date.now() + index,
  //   name: skill,
  // }));
  // const [skills, setSkills] = React.useState(initialSkills);
  // const [skillsName, setSkillsName] = React.useState([]);
  const [newSkill, setNewSkill] = React.useState("");
  // const [searchResults, setSearchResults] = React.useState([]);
  const [files, setFiles] = React.useState({
    GST: supplierDetails ? supplierDetails.gst_doc : null,
    CIN: supplierDetails ? supplierDetails.CIN_doc : null,
    PAN: supplierDetails ? supplierDetails.pan_doc : null,
  });

  //   Country City State
  const [countries] = React.useState(Country.getAllCountries());
  const [selectedCountry, setSelectedCountry] = React.useState("");
  const [state, setState] = React.useState([]);
  const [selectedState, setSelectedState] = React.useState("");
  const [city, setCity] = React.useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);

  // Snackbar
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  // Show Skill
  const [showSkill, setShowSkill] = React.useState(false);

  const handleAlert = () => {
    setAlert(false);
  };

  // Add and remove skills
  // const handleAddSkills = (selectedSkill) => {
  //   if (selectedSkill.trim() !== "") {
  //     if (skills.some((skill) => skill.name === selectedSkill)) {
  //       setAlertContent("Skill already exists");
  //       setAlertType("error");
  //       setAlert(true);
  //     } else {
  //       const newSkillObject = {
  //         id: Date.now(),
  //         name: selectedSkill,
  //       };

  //       setSkills([...skills, newSkillObject]);
  //     }

  //     // Reset the input field after adding
  //     setNewSkill("");
  //   }
  // };

  // const handleRemoveSkill = (id) => {
  //   const updatedSkills = skills.filter((skill) => skill.id !== id);
  //   setSkills(updatedSkills);
  // };

  //   Add and Remove Files
  const handleFileChange = (event, docType) => {
    const selectedFile = event.target.files[0];

    setFiles((prevFiles) => ({
      ...prevFiles,
      [docType]: selectedFile,
    }));
  };

  const handleRemoveFile = (docType) => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [docType]: null,
    }));
  };

  const initialValues = {
    first_name: supplierDetails.supplier_admin_name,
    last_name: supplierDetails.supplier_last_name,
    mobile: supplierDetails.supplier_admin_mobile,
    // supplier_code: supplierDetails.supplier_code,
    supplier_org_name: supplierDetails.supplier_org_name,
    business_address: supplierDetails.business_address,
    pincode: supplierDetails.pincode,
    city: supplierDetails.city,
    state: supplierDetails.state,
    country: supplierDetails.country,
    is_preffered_supplier: supplierDetails.is_preffered_supplier,
    // No longer editable in the UI, but still round-tripped: updateUser() lists
    // this in its Sequelize `fields` whitelist, so omitting it from the payload
    // would set the column to NULL and silently drop ACX attribution for any
    // supplier that has it enabled (see ExternalAcxService.isAcxEnabled).
    acx_job_description_enabled: supplierDetails.acx_job_description_enabled || "N",
    candidate_submission_email_enabled: supplierDetails.candidate_submission_email_enabled || "Y",
    referred_by: supplierDetails.referred_by,
    supplier_additional_email: supplierDetails.supplier_additional_email,
    gst_number: supplierDetails.gst_number,
    pan_number: supplierDetails.pan_number,
    CIN: supplierDetails.CIN,
    coreSkillId: supplierDetails.coreSkillId || ""
  };
  const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const onSubmit = async (values) => {
    if (
      // skills.length === 0 ||
      files.GST == null ||
      files.CIN == null ||
      files.PAN == null
    ) {
      setIsFormSubmitted(true);
    } else {
      try {
        const formData = new FormData();
        formData.append("first_name", values.first_name);
        formData.append("last_name", values.last_name);
        formData.append("mobile", values.mobile);
        formData.append("role_name", "supplier");
        formData.append("org_name", "sty");
        // formData.append("supplier_code", values.supplier_code);
        formData.append("supplier_org_name", values.supplier_org_name);
        formData.append("business_address", values.business_address);
        formData.append("pincode", values.pincode);
        formData.append("city", values.city);
        formData.append("state", values.state);
        formData.append("country", values.country);
        formData.append("is_preffered_supplier", values.is_preffered_supplier);
        // Hidden passthrough — preserves the stored value, see initialValues above.
        formData.append("acx_job_description_enabled", values.acx_job_description_enabled);
        formData.append("candidate_submission_email_enabled", values.candidate_submission_email_enabled);
        formData.append("referred_by", values.referred_by);
        formData.append(
          "supplier_additional_email",
          values.supplier_additional_email
        );
        formData.append("gst_number", values.gst_number);
        formData.append("pan_number", values.pan_number);
        formData.append("CIN", values.CIN);
        // formData.append("skills", skillsName);
        formData.append("gst_doc", files.GST);
        formData.append("pan_doc", files.PAN);
        formData.append("CIN_doc", files.CIN);
        // formData.append("coreSkillId", values.coreSkillId);
        const coreSkillIds = skills.map(skill => skill.coreSkillId);
        formData.append('coreSkillIds', JSON.stringify(coreSkillIds));
        const res = await API.put(
          `/api/users/supplier/${supplierDetails.supplier_id}`,
          formData,
          config
        );
        setIsFormSubmitted(false);
        setAlertContent(res?.data?.message);
        setAlertType("success");
        setAlert(true);
        setTimeout(() => {
          navigate("/suppliermanagement");
        }, 1500);
      } catch (error) {
        setIsFormSubmitted(false);
        setAlertContent(error.response.data.message);
        setAlertType("error");
        setAlert(true);
      }
    }
  };

  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(2, "Minimum 2 characters are required.")
      .max(50, "Maximum length is 50 characters.")
      .matches(/^[A-Za-z\s]+$/, "Only alphabetic characters and spaces are allowed.")
      .matches(/^\S.*\S$/, "Spaces at the start and end are not allowed.")
      .required("This field is required."),
    last_name: Yup.string()
      .min(2, "Minimum 2 characters are required.")
      .max(50, "Maximum length is 50 characters.")
      .matches(/^[A-Za-z\s]+$/, "Only alphabetic characters and spaces are allowed.")
      .matches(/^\S.*\S$/, "Spaces at the start and end are not allowed.")
      .required("This field is required."),

    mobile: Yup.string()
      .required("This field is required.")
      .matches(
        /^\+91[6-9]\d{9}$/,
        "Please enter a valid 13-digit number starting with +91 and followed by 10 digits."
      ),
    // supplier_code: Yup.string()
    //   .required("This field is required.")
    //   .min(8, "Minimum 8 caharacter is required.")
    //   .max(8, "Maximum 8 caharacter is required.")
    //   .matches(/^\S.*\S$/, "Spaces at the start and end are not allowed."),
    supplier_org_name: Yup.string()
      .required("This field is required.")
      .min(1, "Minimum 1 caharacter is required.")
      .max(50, "Maximum length is 50 characters."),
    business_address: Yup.string()
      .required("This field is required.")
      .min(1, "Minimum 1 caharacter is required.")
      .max(1000, "Maximum length is 1000 characters.")
      .matches(/^[^\s].*$/, "Address should not start with a space."),
    pincode: Yup.string()
      .required("This field is required.")
      .matches(/^[0-9]{6}$/, "Zip Code must be exactly 6 digits."),
    city: Yup.string().required("This field is required."),
    state: Yup.string().required("This field is required."),
    country: Yup.string().required("This field is required."),
    is_preffered_supplier: Yup.string().required("This field is required."),
    referred_by: Yup.string().required("This field is required."),
    supplier_additional_email: Yup.string()
      .email("Invalid email address")
      .required("This field is required."),
    gst_number: Yup.string()
      .trim()
      .required("GST number is required")
      .matches(
        /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[0-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/,
        "Invalid GST number"
      ),
    pan_number: Yup.string()
      .required("PAN number is required")
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number format"),
    CIN: Yup.string()
      .matches(
        /^[A-Z]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/,
        "Please enter a valid CIN."
      )
      .required("CIN is required"),
    coreSkillId: Yup.number().notRequired("Core Skill is required"),
  });
  // const debouncedQueryList = useDebounce(newSkill, 500);

  // const handleSearchSkills = async () => {
  //   if (newSkill !== "") {
  //     let url = `/api/skill/skill_list?search=${debouncedQueryList}`;
  //     try {
  //       const res = await API.get(url, config);
  //       setSearchResults(res?.data?.skill);
  //     } catch (error) {
  //       setAlertContent(error?.response?.data?.message);
  //       setAlertType("error");
  //       setAlert(true);
  //     }
  //   } else {
  //     setSearchResults([]);
  //   }
  // };

  const initialSkills = supplierDetails.coreSkills?.map(skill => ({
    id: skill.id,  // Use actual core skill ID
    name: skill.name,
    coreSkillId: skill.supplier_core_skill?.coreSkillId  // Store the linked skill ID
  })) || [];
  const [skills, setSkills] = React.useState(initialSkills);

  // Updated skills name extraction for form submission
  const skillsName = skills.map(skill => skill.name).join(',');

  // Core Skills dropdown state (for adding new skills)
  const [coreSkills, setCoreSkills] = React.useState([]);
  const [searchResults, setSearchResults] = React.useState([]);
  // const [coreSkills, setCoreSkills] = React.useState([]);

  // React.useEffect(() => {
  //   const fetchCoreSkills = async () => {
  //     try {
  //       const res = await API.get("/api/core-skill/coreSkills", config);
  //       const formatted = res?.data?.coreSkills?.map(item => ({
  //         id: item.id,
  //         value: item.id,
  //         label: item.name,
  //       }));
  //       setCoreSkills(formatted);
  //     } catch (error) {
  //       setAlertContent("Failed to load Core Skills");
  //       setAlertType("error");
  //       setAlert(true);
  //     }
  //   };
  //   fetchCoreSkills();
  // }, []);

  React.useEffect(() => {
    const fetchCoreSkills = async () => {
      try {
        const res = await API.get('/api/core-skill/coreSkills', config);
        // Filter out already selected skills
        const availableSkills = res?.data?.coreSkills?.filter(
          available => !skills.some(selected => selected.coreSkillId === available.id)
        ) || [];

        const formatted = availableSkills.map(item => ({
          id: item.id,
          value: item.id,
          label: item.name
        }));

        setCoreSkills(formatted);
      } catch (error) {
        setAlertContent('Failed to load Core Skills');
        setAlertType('error');
        setAlert(true);
      }
    };
    fetchCoreSkills();
  }, [skills]);

  const handleAddCoreSkill = (selectedSkillId) => {
    const selectedSkill = coreSkills.find(skill => skill.id === selectedSkillId);
    if (selectedSkill) {
      const newSkill = {
        id: Date.now() + Math.random(), // Temp ID for UI
        name: selectedSkill.label,
        coreSkillId: selectedSkill.value
      };
      setSkills([...skills, newSkill]);
      // Clear search/selection
      setNewSkill('');
      setShowSkill(false);
    }
  };

  const handleRemoveSkill = (skillId) => {
    const updatedSkills = skills.filter(skill => skill.id !== skillId);
    setSkills(updatedSkills);
  };

  const navigateToPreviousPage = () => {
    navigate(-1);
  };

  // React.useEffect(() => {
  //   handleSearchSkills();
  // }, [debouncedQueryList]);

  React.useEffect(() => {
    countries.map((item, index) => {
      if (item.name === supplierDetails.country) {
        setSelectedCountry(item);
      }
    });
  }, []);

  React.useEffect(() => {
    state.map((item, index) => {
      if (item.name === supplierDetails.state) {
        setSelectedState(item);
      }
    });
  }, [selectedCountry, state]);

  React.useEffect(() => {
    if (selectedCountry) {
      setState(State.getStatesOfCountry(selectedCountry.isoCode));
    }
  }, [selectedCountry]);

  React.useEffect(() => {
    if (selectedState) {
      setCity(
        City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode)
      );
    }
  }, [selectedState]);

  // React.useEffect(() => {
  //   const skillsNames = skills.map((skill) => skill.name);
  //   setSkillsName(skillsNames);
  // }, [skills]);

  return (
    <div style={{ marginTop: 20 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
        Back
      </Button>
      <div
        style={{
          border: "1px solid #989898",
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "20px",
            fontWeight: "500",
            letterSpacing: 1,
            textAlign: "left",
          }}
        >
          <span>Edit Supplier</span>
          <div style={{ display: "grid" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              {(props) => (
                <Form noValidate>
                  <Grid container spacing={2}>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>First Name <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="first_name"
                        fullWidth
                        error={
                          props.errors.first_name && props.touched.first_name
                        }
                        size="small"
                        helperText={<ErrorMessage name="first_name" />}
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Last Name <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="last_name"
                        fullWidth
                        error={
                          props.errors.last_name && props.touched.last_name
                        }
                        size="small"
                        helperText={<ErrorMessage name="last_name" />}
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Phone Number <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="mobile"
                        fullWidth
                        error={props.errors.mobile && props.touched.mobile}
                        size="small"
                        helperText={<ErrorMessage name="mobile" />}
                        required
                      />
                    </Grid>
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Supplier Code</span>
                      <Field
                        as={TextField}
                        name="supplier_code"
                        fullWidth
                        error={
                          props.errors.supplier_code &&
                          props.touched.supplier_code
                        }
                        size="small"
                        helperText={<ErrorMessage name="supplier_code" />}
                        required
                      />
                    </Grid> */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>
                        Supplier Organisation Name <span style={{ color: "red" }}>*</span>
                      </span>
                      <Field
                        as={TextField}
                        name="supplier_org_name"
                        fullWidth
                        error={
                          props.errors.supplier_org_name &&
                          props.touched.supplier_org_name
                        }
                        size="small"
                        helperText={<ErrorMessage name="supplier_org_name" />}
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Zip Code <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="pincode"
                        fullWidth
                        error={props.errors.pincode && props.touched.pincode}
                        size="small"
                        helperText={<ErrorMessage name="pincode" />}
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Country <span style={{ color: "red" }}>*</span></span>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={Boolean(
                          props &&
                          props.touched &&
                          props.touched.country &&
                          props.errors &&
                          props.errors.country
                        )}
                        className={classes.input_root}
                      >
                        <Field
                          as={Select}
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: 200, width: 100 } },
                          }}
                          name="country"
                          id="select"
                          variant="outlined"
                          placeholder="Select country"
                          error={Boolean(
                            props &&
                            props.touched &&
                            props.touched.country &&
                            props.errors &&
                            props.errors.country
                          )}
                          size="small"
                          required
                          className={classes.input_root}
                          displayEmpty
                        >
                          {countries.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.name}
                              onClick={() => setSelectedCountry(item)}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                        </Field>
                        <FormHelperText sx={{ color: "red" }}>
                          {props &&
                            props.touched &&
                            props.touched.country &&
                            props.errors &&
                            props.errors.country}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>State <span style={{ color: "red" }}>*</span></span>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={Boolean(
                          props &&
                          props.touched &&
                          props.touched.state &&
                          props.errors &&
                          props.errors.state
                        )}
                      >
                        <Field
                          as={Select}
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: 200, width: 100 } },
                          }}
                          name="state"
                          id="select"
                          variant="outlined"
                          placeholder="Select state"
                          error={Boolean(
                            props &&
                            props.touched &&
                            props.touched.state &&
                            props.errors &&
                            props.errors.state
                          )}
                          size="small"
                          required
                          className={classes.input_root}
                          displayEmpty
                        >
                          {state.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.name}
                              onClick={() => setSelectedState(item)}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                        </Field>
                        <FormHelperText sx={{ color: "red" }}>
                          {props &&
                            props.touched &&
                            props.touched.state &&
                            props.errors &&
                            props.errors.state}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>City <span style={{ color: "red" }}>*</span></span>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={Boolean(
                          props &&
                          props.touched &&
                          props.touched.city &&
                          props.errors &&
                          props.errors.city
                        )}
                        className={classes.input_root}
                      >
                        <Field
                          as={Select}
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: 200, width: 100 } },
                          }}
                          name="city"
                          id="select"
                          variant="outlined"
                          placeholder="Select City"
                          error={Boolean(
                            props &&
                            props.touched &&
                            props.touched.city &&
                            props.errors &&
                            props.errors.city
                          )}
                          size="small"
                          required
                          className={classes.input_root}
                          displayEmpty
                        >
                          {city.map((item, index) => (
                            <MenuItem key={index} value={item.name}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Field>
                        <FormHelperText sx={{ color: "red" }}>
                          {props &&
                            props.touched &&
                            props.touched.city &&
                            props.errors &&
                            props.errors.city}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Preferred Supplier <span style={{ color: "red" }}>*</span></span>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={Boolean(
                          props &&
                          props.touched &&
                          props.touched.is_preffered_supplier &&
                          props.errors &&
                          props.errors.is_preffered_supplier
                        )}
                      >
                        <Field
                          as={Select}
                          name="is_preffered_supplier"
                          id="select"
                          variant="outlined"
                          error={Boolean(
                            props &&
                            props.touched &&
                            props.touched.is_preffered_supplier &&
                            props.errors &&
                            props.errors.is_preffered_supplier
                          )}
                          size="small"
                          required
                          displayEmpty
                        >
                          {PreferredSupplier.map((name) => {
                            return (
                              <MenuItem key={name.id} value={name.pref}>
                                {name.prefName}
                              </MenuItem>
                            );
                          })}
                        </Field>
                        <FormHelperText sx={{ color: "red" }}>
                          {props &&
                            props.touched &&
                            props.touched.is_preffered_supplier &&
                            props.errors &&
                            props.errors.is_preffered_supplier}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Candidate Submission Email (ACX)</span>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        <Field
                          as={Select}
                          name="candidate_submission_email_enabled"
                          id="select"
                          variant="outlined"
                          size="small"
                          displayEmpty
                        >
                          {PreferredSupplier.map((name) => {
                            return (
                              <MenuItem key={name.id} value={name.pref}>
                                {name.prefName}
                              </MenuItem>
                            );
                          })}
                        </Field>
                      </FormControl>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Referred By <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="referred_by"
                        fullWidth
                        error={
                          props.errors.referred_by && props.touched.referred_by
                        }
                        size="small"
                        helperText={<ErrorMessage name="referred_by" />}
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Additional Email <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="supplier_additional_email"
                        fullWidth
                        error={
                          props.errors.supplier_additional_email &&
                          props.touched.supplier_additional_email
                        }
                        size="small"
                        helperText={
                          <ErrorMessage name="supplier_additional_email" />
                        }
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>GST Number <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="gst_number"
                        fullWidth
                        error={
                          props.errors.gst_number && props.touched.gst_number
                        }
                        size="small"
                        helperText={<ErrorMessage name="gst_number" />}
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>PAN Number <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="pan_number"
                        fullWidth
                        error={
                          props.errors.pan_number && props.touched.pan_number
                        }
                        size="small"
                        helperText={<ErrorMessage name="pan_number" />}
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>CIN <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="CIN"
                        fullWidth
                        error={props.errors.CIN && props.touched.CIN}
                        size="small"
                        helperText={<ErrorMessage name="CIN" />}
                        required
                      />
                    </Grid>

                    <Grid item xl={8} lg={8} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Business Address <span style={{ color: "red" }}>*</span></span>
                      <Field
                        as={TextField}
                        name="business_address"
                        multiline
                        rows={5}
                        fullWidth
                        error={
                          props.errors.business_address &&
                          props.touched.business_address
                        }
                        size="small"
                        helperText={<ErrorMessage name="business_address" />}
                        required
                      />
                    </Grid>

                    {/* Skills
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Skills</span>

                      <Grid container style={{ marginBottom: "10px" }}>
                        <Grid
                          item
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexWrap: "wrap",
                          }}
                        >
                          {skills.map((skill) => (
                            <div
                              style={{
                                display: "flex",
                                background: "#2777AA",
                                paddingLeft: "0.8rem",
                                paddingRight: "0.8rem",
                                paddingTop: ".2rem",
                                paddingBottom: ".2rem",
                                gap: "10px",
                                color: "white",
                                borderRadius: "1.99rem",
                              }}
                              key={skill.id}
                            >
                              <div style={{ fontSize: "18px" }}>
                                {skill.name}
                              </div>
                              <span
                                style={{ cursor: "pointer", fontSize: "18px" }}
                                onClick={() => handleRemoveSkill(skill.id)}
                              >
                                X
                              </span>
                            </div>
                          ))}
                        </Grid>
                      </Grid>

                      <TextField
                        fullWidth
                        size="small"
                        autoComplete="none"
                        value={newSkill}
                        onChange={(e) => {
                          setNewSkill(e.target.value);
                          setShowSkill(true);
                        }}
                      // style={{ paddingBottom: "15px" }}
                      />

                      {isFormSubmitted && skills.length === 0 && (
                        <div
                          style={{
                            color: "#d32f2f",
                            marginLeft: "14px",
                            fontWeight: 400,
                            fontSize: "0.75rem",
                          }}
                        >
                          This Field is required
                        </div>
                      )}

                      {searchResults.length > 0 && showSkill
                        ? searchResults.map((result) => (
                          <div
                            key={result.skill_id}
                            style={{
                              display: "flex",
                              paddingLeft: "0.8rem",
                              paddingRight: "0.8rem",
                              paddingTop: ".2rem",
                              paddingBottom: ".2rem",
                              gap: "10px",
                              border: "1px solid #c5c2c2",
                              borderRadius: "0.15rem",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleAddSkills(result.skill_name);
                              setShowSkill(false);
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              {result.skill_name}
                            </div>
                          </div>
                        ))
                        : null}
                    </Grid> */}
                    {/* Existing Skills Display */}
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Current Core Skills</span>
                      <Grid container style={{ marginBottom: '10px' }}>
                        <Grid item style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                          {skills.map(skill => (
                            <div key={skill.id} style={{
                              display: 'flex',
                              background: '#2777AA',
                              padding: '0.2rem 0.8rem',
                              gap: '10px',
                              color: 'white',
                              borderRadius: '1.99rem'
                            }}>
                              <div style={{ fontSize: '18px' }}>{skill.name}</div>
                              <span
                                style={{ cursor: 'pointer', fontSize: '18px' }}
                                onClick={() => handleRemoveSkill(skill.id)}
                              >
                                ×
                              </span>
                            </div>
                          ))}
                        </Grid>
                      </Grid>

                      {isFormSubmitted && skills.length === 0 && (
                        <div style={{ color: '#d32f2f', marginLeft: '14px', fontWeight: '400', fontSize: '0.75rem' }}>
                          At least one Core Skill is required
                        </div>
                      )}
                    </Grid>

                    {/* Add New Core Skill Dropdown */}
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Add Core Skill</span>
                      <FormControl fullWidth variant="outlined" size="small" error={props.touched.coreSkillId && Boolean(props.errors.coreSkillId)}>
                        <Field
                          as={Select}
                          name="coreSkillId"
                          displayEmpty
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            props.setFieldValue('coreSkillId', e.target.value);
                            if (e.target.value !== '') {
                              handleAddCoreSkill(e.target.value);
                            }
                          }}
                          value={props.values.coreSkillId}
                        >
                          <MenuItem value=""><em>Select Core Skill</em></MenuItem>
                          {coreSkills.map(option => (
                            <MenuItem key={option.id} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Field>
                        <FormHelperText sx={{ color: 'red' }}>
                          <ErrorMessage name="coreSkillId" />
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    {/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Core Skill</span>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={props.touched.coreSkillId && Boolean(props.errors.coreSkillId)}
                      >
                        <Field
                          as={Select}
                          name="coreSkillId"
                          displayEmpty
                          size="small"
                          variant="outlined"
                          onChange={e => props.setFieldValue("coreSkillId", e.target.value)}
                          value={props.values.coreSkillId}
                        >
                          <MenuItem value="">
                            <em>Select Core Skill</em>
                          </MenuItem>
                          {coreSkills.map(option => (
                            <MenuItem key={option.id} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Field>
                        <FormHelperText sx={{ color: "red" }}>
                          <ErrorMessage name="coreSkillId" />
                        </FormHelperText>
                      </FormControl>
                    </Grid> */}
                    {/* File Upload */}
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div
                        style={{
                          marginTop: 20,
                          border: "1px solid #989898",
                          borderRadius: "10px",
                          padding: "15px",
                        }}
                      >
                        <Grid container>
                          {Object.entries(files).map(
                            ([docType, file], index) => (
                              <Grid container spacing={2} key={index}>
                                {/* 1st Column */}
                                <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                                  {`${docType} Document`}
                                </Grid>

                                {/* 2nd Column */}
                                <Grid
                                  item
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={6}
                                  display="flex"
                                  alignItems="center"
                                >
                                  {file && (
                                    <>
                                      {file.name ? (
                                        <div>{file.name}</div>
                                      ) : (
                                        <div>{file}</div>
                                      )}

                                      <DeleteIcon
                                        style={{
                                          cursor: "pointer",
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                        onClick={() =>
                                          handleRemoveFile(docType)
                                        }
                                      />
                                    </>
                                  )}
                                </Grid>

                                {/* 3rd Column */}
                                <Grid
                                  item
                                  xl={3}
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  display="flex"
                                  justifyContent="flex-end"
                                >
                                  <Button
                                    onClick={() =>
                                      fileInputRefs[docType].current.click()
                                    }
                                  >
                                    Browse
                                  </Button>
                                  <input
                                    type="file"
                                    hidden="true"
                                    onChange={(e) =>
                                      handleFileChange(e, docType)
                                    }
                                    ref={fileInputRefs[docType]}
                                  />
                                </Grid>
                                {isFormSubmitted && files[docType] == null && (
                                  <div
                                    style={{
                                      color: "#d32f2f",
                                      marginLeft: "2rem",
                                      fontWeight: 400,
                                      fontSize: "0.75rem",
                                    }}
                                  >
                                    This Field is required
                                  </div>
                                )}
                              </Grid>
                            )
                          )}
                        </Grid>
                      </div>
                    </Grid>
                    {/* Submit */}
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          aria-haspopup="true"
                          style={{
                            background: (props.isValid && (props.dirty || JSON.stringify(skills) !== JSON.stringify(initialSkills) || files.GST !== supplierDetails.gst_doc || files.CIN !== supplierDetails.CIN_doc || files.PAN !== supplierDetails.pan_doc)) ? "#2777AA" : "#989898",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            letterSpacing: 1,
                          }}
                          type="submit"
                          disabled={!props.isValid || !(props.dirty || JSON.stringify(skills) !== JSON.stringify(initialSkills) || files.GST !== supplierDetails.gst_doc || files.CIN !== supplierDetails.CIN_doc || files.PAN !== supplierDetails.pan_doc)}
                        >
                          Submit
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                  <Notification
                    message={alertContent}
                    open={alert}
                    severity={alertType}
                    onClose={handleAlert}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSupplier;

const PreferredSupplier = [
  { id: 1, pref: "Y", prefName: "Yes" },
  { id: 2, pref: "N", prefName: "No" },
];
